/**
 * Registro do Service Worker (PWA).
 * Usa o virtual import gerado pelo vite-plugin-pwa.
 * Em ambiente sem PWA (testes/dev), o try/catch torna a chamada inofensiva.
 */
export async function registerServiceWorker(): Promise<void> {
  if (typeof window === 'undefined') return;
  try {
    // Quando um SW novo assume o controle (deploy), recarrega UMA vez para
    // garantir que o HTML/bundles em execução são os da versão nova.
    if ('serviceWorker' in navigator) {
      let reloaded = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (reloaded) return;
        reloaded = true;
        window.location.reload();
      });
    }
    const { registerSW } = await import('virtual:pwa-register');
    registerSW({
      immediate: true,
      onNeedRefresh() {
        // Hook para futura UI de "nova versão disponível"
        // Mantemos silencioso por enquanto — autoUpdate cuida do reload na próxima navegação.
      },
      onOfflineReady() {
        // App pronto para uso offline.
      },
      onRegisterError(err) {
        // eslint-disable-next-line no-console
        console.warn('[sw] register error', err);
      },
    });
  } catch {
    // Plugin PWA não ativo neste contexto (ex: build sem vite-plugin-pwa) — ignora.
  }
}
